namespace advisorop.components.advisor {

    export class AdvisorHouseholdDashboardController {
        $router;
        accounts;
        noAssetAllocHistAccounts;
        insuranceAccounts = [];
        annuityAccounts = [];
        accountsWithHoldingsInfo;
        household: domains.IHousehold;
        householdId: number;
        showClosedInactive: boolean = false;
        mvDate: Date = null;
        showAssetAllocation = 1;
        chartData: Array<domains.IChartDataSource>;
        allowHistCharts: boolean = true;
        showHistChart: boolean = false;
        histChartView: boolean = false;
        histChrData = [];
        histChartData = []
        histChartType: string = "1";
        histChartDateType: string = "1";
        accountGroupType: domains.AccountGroupType = domains.AccountGroupType.RTG;
        dashboardType: domains.DashboardType = domains.DashboardType.HOUSEHOLD;
        title: string;
        docuSignWind: Window;
        rtgAccountGroupType: domains.AccountGroupType = domains.AccountGroupType.RTG;
        chartHDAccountsController: advisorop.components.widgets.ChartHdAccountsController;
        hdg: DevExpress.ui.dxDataGridOptions;
        asg: AccountSummaryGridController;
        acctDropdownPrepared: boolean = false;
        hdAccountsLoading: boolean = false; // Flag to prevent multiple calls to loadHDAccounts


        advOpParams: { level: string, entityId: string }; // entityId: 4918    U-DEMO04   DEMO01 | level:  HH CG AC
        // PP and Orion direct API Access
        ppParams: { pplevel: string, ppclientid: string }; // ppclientid: 4918    U-DEMO04   DEMO01 | pplevel:  HH CG AC

        chartDataParams: {
            level?: string,
            householdId?: number,
            accountGroupType?: number,
            groupId?: number,
            accountId?: number,
            boModelId?: number,
            showClosedInactive?: boolean,
            additionalData?: string
        }

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#householdContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        chartDataLoading: boolean = false;
        chartLoadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#householdChartContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Retrieving data...",
            bindingOptions: {
                visible: "vm.chartDataLoading"
            }
        }

        helpPopupOptions: DevExpress.ui.dxPopoverOptions = {
            target: "#advisorHHDashHelp",
            showEvent: "mouseenter",
            hideEvent: "mouseleave",
            position: "left",
            width: 400,
            animation: {
                show: {type: "pop", from: { scale: 0 }, to: { scale: 1 }},
                hide: {type: "fade", from: 1, to: 0 }
            },
            showTitle: true,
            title: "Account Values Widget",
            visible: false
        }

        //showStickyNotes: boolean = false;

        //stickyNotesPopupOption: DevExpress.ui.dxPopupOptions = {
        //    deferRendering: false,
        //    width: '50%',
        //    height: 700,
        //    showTitle: true,
        //    title: "Household Notes",
        //    dragEnabled: true,
        //    closeOnOutsideClick: true,
        //    showCloseButton: true,
        //    bindingOptions: {
        //        visible: "vm.showStickyNotes",
        //    },
        //}

        exportToExcelUrl = (reportType: string) => {
            var level = "H";
            var groupId = null;
            var accountId = null;
            var boModelId = null;

            const url = this.hhApi.getChartsUrl(this.householdId, this.accountGroupType, level,
                groupId, accountId, boModelId, this.showClosedInactive, null, true, false);

            //console.log(url);

            return `${url}&reportType=${reportType}`;
        };

        ctlAccountDdl: advisorop.components.common.AccountsDdlController;

        analysts: Array<domains.ISalesforceAnalystData> = [];

        static $inject = [`advisorService`, `householdApi`, `acgHelper`, `advisorDashboardService`, `$window`];
        constructor(
            private advisorService: services.AdvisorService,
            private hhApi: services.HouseholdApi,
            private acgs: services.AcgHelper,
            private ads: services.AdvisorDashboardService,
            private $window) {
            this.chartData = this.ads.getEmptyChartData();
            this.histChartData = [];
            this.chartDataParams = {
                level: null,
                householdId: null,
                accountGroupType: null,
                groupId: null,
                accountId: null,
                boModelId: null,
                showClosedInactive: null,
                additionalData: null
            };
            this.hdg = {
                export: {
                    enabled: false,
                    fileName: "NoAssetAllocHistAccounts"
                },
                bindingOptions: {
                    dataSource: "vm.noAssetAllocHistAccounts"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "There are no accounts",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'accountName', caption: 'Account name', cellTemplate: 'colFullName2' }
                ]
            };
            $window = $window;
        }

        onChangeAccountGroupType() {
            //console.log("In onChangeAccountGroupType: Account group type is:" + this.accountGroupType);

            this.ctlAccountDdl.selItemID = "Nothing selected...";
            this.ctlAccountDdl.selItemData = null;

            if (this.isInitializing == false)
                this.loadHDAccounts();
        };

        openPPReport = (report: string): void => {
            this.ads.calculateBackOfficeParamsAsync(this.advOpParams.level, this.advOpParams.entityId).then(params => {
                this.ads.openBackOfficeReport(report, params);
            });
        }

        hideAssetAllocationPanelAndEmptyData = () => {
            console.log("There are no charts...");
            this.showAssetAllocation = 0;
            this.ctlAccountDdl.selItemID = "no data";
            this.ctlAccountDdl.selItemData = null;
            this.chartData = this.ads.getEmptyChartData();
        }

        exportToXlsx() {
            var level = "H";
            var groupId = null;
            var accountId = null;
            var boModelId = null;

            this.ads.getHdChartXlsx(level, this.householdId, this.accountGroupType,
                groupId, accountId, boModelId, this.showClosedInactive)
                .then(resp => {
                    //console.log(resp.data);
                });
        }

        // Updates the structure in place
        setVisibilityOfData(dataSet: Array<domains.IStackedBarChartDataset>, histChartType: string) {
            if (dataSet && dataSet.length > 0) {
                if (histChartType == "1" || histChartType == "2") {
                    // percentage or value based = show all
                    dataSet.forEach(function (r, a) {
                        if (r)
                            r.visible = "1";
                    });
                } else if (histChartType == "3") {
                    // Hide Value Line
                    dataSet.forEach(function (r, a) {
                        if (r) {
                            if (r.seriesname == "Total Value")
                                r.visible = "0";
                            else
                                r.visible = "1";
                        }
                    });
                } else if (histChartType == "4") {
                    // Show Value Line Only
                    dataSet.forEach(function (r, a) {
                        if (r) {
                            if (r.seriesname == "Total Value")
                                r.visible = "1";
                            else
                                r.visible = "0";
                        }
                    });
                }
            }
        }

        toggleDataVisibility() {
            // show or hide the line chart data based on the options selected by the user. 
            this.histChrData.forEach(v => { if (v.dataset && v.dataset.length > 0) this.setVisibilityOfData(v.dataset, this.histChartType); });
        }

        setStackPercentAttribute() {
            if (this.chartHDAccountsController) {
                this.chartHDAccountsController.setChartAttributes(this.histChartType);
            }
        }

        // Sum across like indexes for each series to compute the total for each series and
        // return the line-chart series definition that we can append to the chart dataset structure.
        createLineChartDataset(dataSet: Array<domains.IStackedBarChartDataset>): domains.IStackedBarChartDataset {

            // Initialize an empty chart dataset data structure
            let chartDatasetData: Array<domains.ChartDatasetData> = [];
            if (dataSet && dataSet.length > 0 && dataSet[0].data && dataSet[0].data.length > 0) {
                //console.log("IN HERE, DATASET:", dataSet);
                dataSet[0].data.forEach(f => {
                    var d: domains.ChartDatasetData = { value: 0 };
                    chartDatasetData.push(d);
                });
                // Populate the structure, summing across all of the series
                dataSet.forEach(function (r, a) {
                    r.data.forEach(function (b, i) {
                        chartDatasetData[i].value = (chartDatasetData[i]?.value || 0) + b.value;
                    });
                });
                // Return dataset, specified as line plot
                const ret: domains.IStackedBarChartDataset = {
                    seriesname: "Total Value",
                    renderas: "Line",
                    showvalues: "1",
                    data: chartDatasetData
                };
                return ret;
            }
            return null;
        }

        updateHistChartData() {
            if (this.histChrData && this.histChrData.length > 0 && this.histChrData[0].dataset.length > 0) {
                this.histChartData = [];
                //console.log("HISTCHRDATA", this.histChrData);
                angular.copy(this.histChrData, this.histChartData);
            }
        }

        bindChartHDAccountsWidget(ctrl: advisorop.components.widgets.ChartHdAccountsController) {
            this.chartHDAccountsController = ctrl;
            this.setStackPercentAttribute();
        }

        loadSelectedChartData() {

            //console.log("In loadSelectedChartData... ");

            this.chartDataLoading = true;

            var dateTypeParam: domains.HistChartDateType;
            if (this.histChartDateType == "1")
                dateTypeParam = domains.HistChartDateType.LAST_SIX_MONTHS;
            else if (this.histChartDateType == "2")
                dateTypeParam = domains.HistChartDateType.LAST_FOUR_QUARTERS;
            else
                dateTypeParam = domains.HistChartDateType.LAST_ONE_WEEK;

            //const getHdChartPromise = this.ads.getHdChartPromise(this.chartDataParams.level, this.chartDataParams.householdId, this.chartDataParams.accountGroupType, this.chartDataParams.groupId, this.chartDataParams.accountId, this.chartDataParams.boModelId, this.chartDataParams.showClosedInactive, this.histChartView, dateTypeParam);
            //
            //// load HD chart data
            //if (getHdChartPromise != null) {
            //    getHdChartPromise.then(response => {
            if (this.chartHDAccountsController) {
                this.chartHDAccountsController.clearHistChartData = true;
                this.histChartData = [];
            }
            this.ads.getHdChartPromise(this.chartDataParams.level, this.chartDataParams.householdId, this.chartDataParams.accountGroupType, this.chartDataParams.groupId, this.chartDataParams.accountId, this.chartDataParams.boModelId, this.chartDataParams.showClosedInactive, this.histChartView, dateTypeParam)
                .then(response => {
                    if (!response || !response.data || !response.data.chartData || response.data.chartData.length <= 0) {
                        this.hideAssetAllocationPanelAndEmptyData();
                    } else {
                        this.showAssetAllocation = 1;
                        this.chartData = response.data.chartData;
                        //console.log("SELECTED CHART DATA", this.chartData);
                        this.chartData.forEach(v => v.chart.caption = this.chartDataParams.additionalData);
                        if (this.histChartView == true) {
                            this.histChrData = response.data.histChartData;
                            if (this.histChrData && this.histChrData.length > 0 && this.histChrData[0].dataset.length > 0) {
                                // Create line chart dataset for the totals
                                this.histChrData.forEach(v => v.dataset?.push(this.createLineChartDataset(v.dataset)));
                                if (this.chartHDAccountsController)
                                    this.chartHDAccountsController.histChartDataExists = true;
                                this.toggleDataVisibility();
                                this.updateHistChartData();
                            } else {
                                if (this.chartHDAccountsController)
                                    this.chartHDAccountsController.histChartDataExists = false;
                            }
                            //console.log("histChartDataExists", this.chartHDAccountsController.histChartDataExists);
                            if (this.histChartView && this.allowHistCharts && !this.showHistChart) {
                                this.showHistChart = true;
                            }
                        }
                    }
                }).finally(() => {
                    this.chartDataLoading = false;
                });
        }

        histChartsToggle(toggle: boolean) {
            this.allowHistCharts = toggle;
            if (toggle == true) {
                if (this.histChartView && !this.showHistChart) {
                    this.showHistChart = true;
                }
            } else {
                this.showHistChart = false;
            }
        }

        asg_onReady = (component) => {
            //console.log("onReady", component);
            this.asg = component;
        }

        hg_onItemSelected = (item, level, additionalData, dbg = 'default') => {

            //console.log("In onItemSelected... item:", item, "level:", level, "additionalData:", additionalData, "dbg:", dbg);

            // when account is changed we need to calculate "PpLevel" and "PpClientId"", which we need for a PP and Orion reports
            this.ppParams = this.ads.calculatePpLevelAndClientId(level, item.boRtgId, item.boCustodialAccountNumber, item.boUMAAccountIdentifierString);

            if (level != "H" && level != "R" && level != "A") {
                this.advOpParams = { level: null, entityId: null }; 
                this.histChartsToggle(false);
                return;
            }

            let entityId = item.accountId; // default to accountId
            if (level == "H") {
                entityId = this.householdId; // for H level we use householdId
            } else if (level == "R") {
                entityId = item.groupId; // for R level we use groupId
            }

            // when account is changed we need to calculate PpLevel and PpClientId, which we needs for a PP reports
            //this.ads.calculateBackOfficeParams(level, entityId);
            this.advOpParams = { level, entityId }; 
            
            this.advisorService.selHDItem = item;
            this.advisorService.selHDLevel = level;
            
            this.chartDataParams.level = level;
            this.chartDataParams.householdId = this.householdId;
            this.chartDataParams.accountGroupType = this.accountGroupType;
            this.chartDataParams.groupId = item.groupId;
            this.chartDataParams.accountId = item.accountId;
            this.chartDataParams.boModelId = item.boModelId;
            this.chartDataParams.showClosedInactive = this.showClosedInactive;
            this.chartDataParams.additionalData = additionalData;

            this.loadSelectedChartData();

            if (level == "H") {
                this.ctlAccountDdl.setSelItemId(this.householdId);
                this.histChartsToggle(true);
            }
            else if (level == "R") {
                this.ctlAccountDdl.setSelItemId(`${this.householdId}_${item.groupId}`);
                this.histChartsToggle(true);
            }
            else if (level == "A") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}`);
                //if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && item.manualHoldingsExSystem == true)
                //    this.hideAssetAllocationPanelAndEmptyData();
                if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                    this.histChartsToggle(false);
                else
                    this.histChartsToggle(true);
            }
            else if (level == "S") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}_${item.boModelId}`);
                //if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && item.manualHoldingsExSystem == true)
                //    this.hideAssetAllocationPanelAndEmptyData();
                if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                    this.histChartsToggle(false);
                else
                    this.histChartsToggle(true);
            }
            //else {
            //    // OA - outside investment accounts where holdings are maintained outside of AdvisorOp,
            //    // we can not show asset allocation for these because they all share the same Security ID
            //    this.hideAssetAllocationPanelAndEmptyData();
            //    if (item.boModelId > 0) {
            //        this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}_${item.boModelId}`);
            //    } else {
            //        this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}`);
            //    }
            //}
        };


        $onInit(): void {
        }

        loadHDAccounts(): void {
            //console.log("in loadHDAcountss... householdId:", this.householdId, "accountGroupType:", this.accountGroupType, "showClosedInactive:", this.showClosedInactive, "hdAccountsLoading:", this.hdAccountsLoading);
            if (this.hdAccountsLoading) {
                return; // Prevent multiple calls
            }
            this.hdAccountsLoading = true;

            this.isInitializing = true;
            this.mvDate = null;
            this.hhApi
                //.getHDAccounts(this.accountGroupType, this.householdId, this.showClosedInactive)
                //.getAccountGroupsSummary(this.householdId, this.accountGroupType, this.showClosedInactive, this.histChartView)
                .getAccountGroupsSummary(this.householdId, this.accountGroupType, this.showClosedInactive)
                .then(response => {

                    //console.log("hh-dashboard: HDAccounts RESPONSE:", response.data);

                    this.accounts = response.data.gridData;
                    if (this.accounts.length > 0) {
                        // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                        this.mvDate = this.accounts[0].marketValueDate;
                    }
                    this.insuranceAccounts = [];
                    this.annuityAccounts = [];
                    if (response.data.hasOwnProperty('insuranceAccounts') && response.data.insuranceAccounts.length > 0)
                        this.insuranceAccounts = response.data.insuranceAccounts;
                    if (response.data.hasOwnProperty('annuityAccounts') && response.data.annuityAccounts.length > 0)
                        this.annuityAccounts = response.data.annuityAccounts;
                    
                    // preparing data structure for DropDown-TreeView content
                    if (this.ctlAccountDdl) {
                        this.acctDropdownPrepared = true;
                        //console.log("PREPARING DROPDOWN DATA!!!!!!BBBBB", this.accounts);
                        this.ctlAccountDdl.prepareDropDownData(this.accounts);
                    } else {
                        //console.log("NOT PREPARING DROPDOWN DATA!!!!!!BBBBB");
                    }

                    if (!response.data || !response.data.charts || response.data.charts.length <= 0) {
                        // hide asset allocation
                        this.hideAssetAllocationPanelAndEmptyData();

                        this.isInitializing = false;
                        this.hdAccountsLoading = false; // Reset after loading completes

                        return;
                    }

                    this.noAssetAllocHistAccounts = this.accounts.filter(f => f.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && f.manualHoldingsExSystem == false);

                    this.chartData = response.data.charts;
                    //console.log("CHART DATA", this.chartData);

                    // Save the current state so that if the user elects to see historical charts
                    // we can load them using the current state
                    this.chartDataParams.level = "H";
                    this.chartDataParams.householdId = this.householdId;
                    this.chartDataParams.accountGroupType = this.accountGroupType;
                    this.chartDataParams.groupId = null;
                    this.chartDataParams.accountId = null;
                    this.chartDataParams.boModelId = null;
                    this.chartDataParams.showClosedInactive = this.showClosedInactive;
                    this.chartDataParams.additionalData = this.household.name + " - Household Level";

                    // this mean that HH must be loaded ...
                    this.chartData.map(v => v.chart.caption = this.chartDataParams.additionalData);

                    this.accountsWithHoldingsInfo = response.data.holdings;

                    //console.log(data);
                    this.showAssetAllocation = 1;
                    this.isInitializing = false;
                    this.hdAccountsLoading = false; // Reset after loading completes
                });
        };

        loadHousehold(): ng.IHttpPromise<domains.IHousehold> {
            this.isInitializing = true;
            return this.advisorService.getHousehold(this.householdId)
                .then((data) => {
                    //console.log(data.data);
                    this.household = data.data;
                    this.isInitializing = false;
                    return this.household;
                })
                .catch((reason) => {
                    console.log("Error during load household");
                    console.log(reason);
                    throw reason;
                });
        }

        onAccountsDdlItemSelected = (itemData) => {
            //console.log("AdvisorHouseholdDashboard: onAccountsDdlItemSelected received... itemData:", itemData);
            //console.log("householdId:", this.householdId);
            if (itemData) {
                // clear selection in HH grid
                $("#dgHouseholds tr.acsrow").each((ind, elm) => {
                    $(elm).removeClass("acsrow");
                });

                // selecting row in dgHouseholds grid
                const dgSummary = DevExpress.ui.dxDataGrid.getInstance($("#dgHouseholds")) as DevExpress.ui.dxDataGrid;

                //SYNC selection on SummaryGrid
                this.acgs.syncDgSummaryGridSelection(itemData.level, itemData.item, this.asg.sortByField, this.asg.rootLevel, dgSummary, this.accounts);

                //let dgSummaryRowIndex;

                //if (itemData.ID == this.householdId) {
                //    dgSummaryRowIndex = 0;
                //} else if (itemData.level == "S") {
                //    // console.log("HH row key", itemData.item);
                //    // first we need to ensure that row is expanded
                //    const dgSummaryRowKey = [this.householdId, itemData.item.groupId, itemData.item.accountId]
                //        .map(m => +m);
                //    dgSummary.expandRow(dgSummaryRowKey).then(vv => {
                //        dgSummaryRowIndex = dgSummary.getRowIndexByKey(itemData.item);
                //        if (dgSummaryRowIndex >= 0) {
                //            const rowEl = dgSummary.getRowElement(dgSummaryRowIndex);
                //            $(rowEl).addClass("acsrow");
                //        }
                //    }, err => console.log(`Error during ExpandRow of dgHouseholds widget...`));
                //} else if (itemData.level == "R") {
                //    const dgSummaryRowKey: any[] = (itemData.ID as string).split("_").map(m => +m);
                //    dgSummaryRowIndex = dgSummary.getRowIndexByKey(dgSummaryRowKey);
                //} else {
                //    const dgSummaryRowKey: any[] = [`${this.householdId}`]
                //        .concat((itemData.ID as string).split("_"))
                //        .map(m => +m);
                //    //console.log("DG SUMMARY ROW KEY:", dgSummaryRowKey);
                //    dgSummaryRowIndex = dgSummary.getRowIndexByKey(dgSummaryRowKey);
                //}

                //dgHouseholdSummary row which needs to be selected
                //if (dgSummaryRowIndex >= 0) {
                //    const rowEl = dgSummary.getRowElement(dgSummaryRowIndex);
                //    $(rowEl).addClass("acsrow");
                //}

                //console.log(`HH row index is:`, dgSummaryRowIndex);
                this.hg_onItemSelected(itemData.item, itemData.level, itemData.caption, 'From onAccountsDdlItemSelected');
            }
        }

        onChangeHistView() {
            if (this.histChartView) {
                if (!this.isInitializing)
                    this.loadSelectedChartData();
            } else {
                this.showHistChart = false;
            }
        }

        onChangeHistChartType() {
            this.setStackPercentAttribute();
            this.toggleDataVisibility();
            this.updateHistChartData();
        }

        onChangeHistChartDateType() {
            if (!this.isInitializing)
                this.loadSelectedChartData();
        }

        onAccountsDdlReady = (ctrl) => {
            this.ctlAccountDdl = ctrl;
            if (this.accounts != undefined && this.accounts != null && this.acctDropdownPrepared == false) {
                //console.log("PREPARING DROPDOWN DATA!!!!!!AAAAA", this.accounts);
                this.acctDropdownPrepared = true;
                this.ctlAccountDdl.prepareDropDownData(this.accounts);
            } else {
                //console.log("NOT PREPARING DROPDOWN DATA!!!!!!AAAAA");
            }
        }

        loadHouseholdAnalysts(): void {
            this.advisorService.getHouseholdAnalysts(this.householdId)
                .then(response => {
                    this.analysts = response.data || [];
                });
        }

        $routerOnActivate(next, previous) {
            this.householdId = <number>next.params.householdId;
            this.loadHousehold()
                .then(data => this.loadHDAccounts());
            this.loadHouseholdAnalysts();
        }

        testDocusign(): void {
            toastr.warning("This function is disabled.");
            //    this.advisorService.testDocusign("qweqweqwe-3123123-drqwwq-12312313123")
            //        .then(response => {
            //            this.docuSignWind = window.open(response.data, "_blank");
            //        }
            //        ); //, err => this.generalService.showError(err));
        }
    }

    class AdvisorHouseholdDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdvisorHouseholdDashboardController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/views/advisor-household-dashboard.html";
        }
    }
    angular.module(Constants.APP).component("advisorHouseholdDashboard", new AdvisorHouseholdDashboard());
}